import React from 'react';

import { Stack } from '@mui/material';

import { isRowApproved, isRowManuallyApproved, isRowManuallyRequired } from '../../manualOverridePersistence';
import ChecklistRuleCard from '../../reportCards/ChecklistRuleCard';
import type { ManualOverrideState } from '../../types';

import type { EgsAgeCoverageRowView } from './types';

const AGE_COVERAGE_RULE =
  'Extra guest surcharge age ranges must cover every age from 0 up to the oldest band, with no gaps.';

interface Props {
  expandedRows: Record<string, boolean>;
  manualOverrides: ManualOverrideState;
  rows: Array<EgsAgeCoverageRowView>;
  onApprovalChange: (rowId: string) => void;
  onToggleDetails: (rowId: string) => void;
  onUnapprovalChange: (rowId: string) => void;
}

export default function AgeCoverageReportCard({
  expandedRows,
  manualOverrides,
  rows,
  onApprovalChange,
  onToggleDetails,
  onUnapprovalChange,
}: Props) {
  return (
    <Stack spacing={1.5}>
      {rows.map((row) => {
        const approved = isRowApproved(row, manualOverrides);

        return (
          <ChecklistRuleCard
            key={row.id}
            approved={approved}
            blocked={!approved && !isRowManuallyRequired(row, manualOverrides) && row.status === 'blocked'}
            dataPoints={row.details}
            dataPointsLabel="Age ranges by guest type"
            expanded={!!expandedRows[row.id]}
            manuallyApproved={isRowManuallyApproved(row, manualOverrides)}
            rule={AGE_COVERAGE_RULE}
            summary={row.summary}
            title={row.name}
            onApprovalChange={() => onApprovalChange(row.id)}
            onToggleExpanded={() => onToggleDetails(row.id)}
            onUnapprovalChange={() => onUnapprovalChange(row.id)}
          />
        );
      })}
    </Stack>
  );
}
